import { Box, Stack } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { SilobagListContextProvider } from '../context';

export function Layout({ children }: PropsWithChildren) {
  return (
    <SilobagListContextProvider>
      <Box
        sx={{
          width: '100%',
          flex: '1 0 auto',
          minHeight: 0,
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: '#FFFFFF',
        }}
      >
        <Stack gap={2} py={2} sx={{ flex: 1, width: '100%' }}>
          {children}
        </Stack>
      </Box>
    </SilobagListContextProvider>
  );
}
